<div attr.tid="{{childConfig.config.controlName}}" (click)="clickControl($event)" class="template-ctrl" #contentElement>
    <div class="tml-tpl-label" *ngIf="!childConfig.config.isLabelHidden">
        <label *ngIf="childConfig.config.controlID!=='FormerEmploymentsDivider' &&childConfig.config.controlID!=='CurrentEmploment' 
        &&childConfig.config.controlID!=='Relationships'">{{childConfig.config.controlName}}<span
                *ngIf="childConfig.config.isRequired" style="color:red;">&nbsp;*</span></label>
    </div>
    <div [ngSwitch]="childConfig.config.controlType" class="static-del">
        <div *ngSwitchCase="'input'">
            <tam-template-input [childConfig]="childConfig">
            </tam-template-input>
        </div>
        <div *ngSwitchCase="'alias'">
            <!-- <tam-template-alias [childConfig]="childConfig">
            </tam-template-alias> -->
            <tam-template-input [childConfig]="childConfig">
            </tam-template-input>
        </div>
        <div *ngSwitchCase="'label'">
            <tam-template-label [childConfig]="childConfig">
            </tam-template-label>
        </div>
        <div *ngSwitchCase="'dropdown'">
            <tam-template-dropdown [childConfig]="childConfig">
            </tam-template-dropdown>
        </div>
        <div *ngSwitchCase="'singleDropdown'">
            <tam-template-dropdown [childConfig]="childConfig">
            </tam-template-dropdown>
        </div>
        <div *ngSwitchCase="'med-input'">
            <tam-template-med [childConfig]="childConfig">
            </tam-template-med>
        </div>
        <div *ngSwitchCase="'msd-input'">
            <tam-template-msd [childConfig]="childConfig">
            </tam-template-msd>
        </div>
        <div *ngSwitchCase="'job-function'">
            <tam-template-job-function [childConfig]="childConfig">
            </tam-template-job-function>
        </div>
        <div *ngSwitchCase="'date'">
            <tam-template-date [childConfig]="childConfig">
            </tam-template-date>
        </div>
        <div *ngSwitchCase="'textarea'">
            <tam-template-area [childConfig]="childConfig">
            </tam-template-area>
        </div>
        <div *ngSwitchCase="'combine-dropdown-input'">
            <tam-template-combine-dropdown-input [childConfig]="childConfig">
            </tam-template-combine-dropdown-input>
        </div>
        <div *ngSwitchCase="'combine-address'">
            <tam-template-address [childConfig]="childConfig">
            </tam-template-address>
        </div>
        <div *ngSwitchCase="'Former-Employment'">
            <tam-template-former-employment [childConfig]="childConfig">
            </tam-template-former-employment>
        </div>
        <div *ngSwitchCase="'Combine-Relationships'">
            <div class="flex-no-config" [style.width.px]="childConfig.css.width">
                <span>Currently Not Configurable</span>
            </div>
        </div>
        <div *ngSwitchCase="'divider'">
            <div attr.tid="{{childConfig.config.controlName}}" class="ct-divider"
                [style.width.px]="childConfig.css.width">
                <span class="line"></span>
                <span class="txt">{{childConfig.config.controlName}}</span>
                <span class="line"></span>
            </div>
        </div>

        <smart-icon name="trash-circle" class="trash-icon" *ngIf="childConfig.config.isRemoved&&isSelected"
            (click)="clickTrash($event,childConfig.config.controlName)"></smart-icon>

    </div>

</div>